import styled from 'styled-components'

export const ContainerContdown = styled.div`
    color: var(--text-title);
    background-color: var(--background-one);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    h1 {
        text-align: center;
        margin-top: 4rem;
        margin-bottom: 2rem;
    }
    .countdown {
        display: flex;
        flex-direction: row;
        .days, .hours {
            margin-right: 6rem;
        }
        .number {
        font-family: Moby;
        }
        .days .number {
            position: relative;
            font-size: 33px;
            bottom: 130px;
            left: 90px;
        }
        .hours .number {
            position: relative;
            font-size: 33px;
            bottom: 130px;
            left: 90px;
        }
        .minutes .number {
            position: relative;
            font-size: 33px;
            bottom: 130px;
            left: 90px;
        }
        h6 {
            margin-left: 4rem;
            font-family: 'Graphik';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 60px;
        }
        .days div, .hours div, .minutes div  {
            height: 220px;
        }
    }
    .discord {
        width: 323px;
        height: 56px;
        left: 798px;
        top: 1583px;
        padding-top: 15px;
        padding-bottom: 20px;

        background: var(--background-season-2);
        border-radius: 40px;
        margin-top: 4rem;
        margin-bottom: 4rem;
        a {
            font-family: 'Graphik';
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 20px;
            display: flex;
            align-items: center;
            text-align: center;
            color: white;
            display: flex;
            justify-content: center;
        }
    }


    @media(max-width: 980px) {
        .countdown {
            .days, .hours {
            margin-right: 2rem;
            }
        }
    }
    @media(max-width: 851px) {
        .countdown {
            .days, .hours {
            margin-right: 2rem;
            }
            .days .number, .hours .number, .minutes .number {
                font-size: 30px;
                bottom: 112px;
                left: 78px;
            }
            img {
                height: 180px;
            }
            h6 {
                margin-left: 4rem;
            }
        }
    }

    @media(max-width: 768px) {
        h1 {
            margin-top: 10rem;
        }
    }

    @media(max-width: 759px) {
        .countdown {
            .days, .hours {
            margin-right: 2rem;
            }
            .days .number, .hours .number, .minutes .number {
                font-size: 30px;
                bottom: 96px;
                left: 58px;
            }
            img {
                height: 147px;
            }
            h6 {
                margin-left: 4rem;
            }
        }
    }
    @media(max-width: 613px) {
        .countdown {
            .days, .hours {
            margin-right: 2rem;
            }
            .days .number, .hours .number, .minutes .number {
                font-size: 30px;
                bottom: 85px;
                left: 49px;
            }
            img {
                height: 122px;
            }
            h6 {
                margin-left: 2rem;
            }
            .days div, .hours div, .minutes div  {
            height: 156px;
        }
        }
    }
    @media(max-width: 520px) {
        .countdown {
            .days, .hours {
            margin-right: 2rem;
            }
            .days .number, .hours .number, .minutes .number {
                font-size: 16px;
                bottom: 63px;
                left: 37px;
            }
            img {
                height: 98px;
            }
            h6 {
                font-size: 16px;
                margin-left: 1rem;
            }
            .days div, .hours div, .minutes div  {
            height: 123px;
            }
        }
    }
    @media(max-width: 425px) {
        h1 {
            margin-top: 4rem;
        }
    }

    @media(max-width: 382px) {
        h1 {
            margin-top: 2rem;
            margin-bottom: 4rem;
            padding-right: 5px;
            padding-top: 28px;
        }
        .countdown {
            .days, .hours {
            margin-right: 2rem;
            }
            .days .number, .hours .number, .minutes .number {
                font-size: 16px;
                bottom: 55px;
                left: 32px;
            }
            img {
                height: 84px;
            }
            h6 {
                font-size: 13px;
                margin-left: 1rem;
            }
            .days div, .hours div, .minutes div  {
            height: 96px;
            }
        }
        .discord {
            width: 273px;
            height: 52px;
            a {
                font-size: 22px;
            }
        }
    }

    @media  (max-width: 320px) {
        .countdown {
            .days .number, .hours .number, .minutes .number {
                left: 27px;
                bottom:55px
            }
            img {
                height: 71px;
            }
        }
    }
`